export const headers = {
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json'
	},
	credentials: 'include'
};



// WEBPACK FOOTER //
// ./react-app-src/shared/constants.js